import AGSRollUp from "ags/states/ags-roll-up";
import gameState from "slotworks/model/game-state";
import BonusResult from "slotworks/model/gameplay/records/results/bonus-result";

export default class CGRollUp extends AGSRollUp {
    protected executeRollup() {
        const record = gameState.getCurrentGame().getRootRecord();
        const gatewayBonus = record.getResultsOfType(BonusResult).filter((result) => result.id === "gateway").pop();
        const isBeforeGateway = gatewayBonus && gatewayBonus.played === false;

        this.hasBonusWin = isBeforeGateway;

        return super.executeRollup();
    }
}
